
/**
 * 获取随机guid
 * @returns guid
 */
export function getGuid() {
    var d = new Date().getTime();
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = (d + Math.random() * 16) % 16 | 0;
        d = Math.floor(d / 16);
        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
    return uuid;
}

export function getNo(number, prefix, totalLength) {
  // 将数字转换为字符串
  let numberStr = number.toString();
  // 计算需要填充的零的数量
  let zerosToFill = totalLength - prefix.length - numberStr.length;
  // 如果数字长度加上前缀长度已经超过了总长度，抛出错误
  if (zerosToFill < 0) {
    throw new Error("Number is too large for the given total length and prefix.");
  }
  // 填充零
  let zeros = "0".repeat(zerosToFill);
  // 拼接最终的单号
  return prefix + zeros + numberStr;
}

/** 默认的guid */
export const dftGuid = '00000000-0000-0000-0000-000000000000';